module.exports = __webpack_public_path__ + "static/media/logoTeacher.d02692e0.svg";